module.exports = __webpack_public_path__ + "static/img/severance-design.dbadbd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/severance-design.jpg
// module id = EMIH
// module chunks = 0